interface SignalUnitOfMeasurements {
    signalUOM: string
    signalUOMAbrv: string
    signalImperialConversion: {
        signalUOMConversionAbrv: string
        signalUOMFormulaName: string
        signalUOMFormulaType: string
        signalUOMFormula: string
    }
    signalMetricConversion: {
        signalUOMConversionAbrv: string
        signalUOMFormulaName: string
        signalUOMFormulaType: string
        signalUOMFormula: string
    }
}
const signalUnitOfMeasurements: SignalUnitOfMeasurements[] = [
    {
        signalUOM: 'Second',
        signalUOMAbrv: 'S',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Hour',
        signalUOMAbrv: 'H',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Meter',
        signalUOMAbrv: 'M',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'Ft',
            signalUOMFormulaName: 'Meters => Feet',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n * 3.2808',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Kilogram',
        signalUOMAbrv: 'K',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'Lbs',
            signalUOMFormulaName: 'Kilograms => Pounds',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n * 2.20462',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Ampere',
        signalUOMAbrv: 'A',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Volt',
        signalUOMAbrv: 'V',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Kelvin',
        signalUOMAbrv: '°K',
        signalImperialConversion: {
            signalUOMConversionAbrv: '°F',
            signalUOMFormulaName: 'Kelvin => Fahrenheit',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n * 9/5 - 459.67',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '°C',
            signalUOMFormulaName: 'Kelvin => Celsius',
            signalUOMFormulaType: 'SI',
            signalUOMFormula: 'n - 273.15',
        },
    },
    {
        signalUOM: 'Celsius',
        signalUOMAbrv: '°C',
        signalImperialConversion: {
            signalUOMConversionAbrv: '°F',
            signalUOMFormulaName: 'Celsius => Fahrenheit',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n * 9/5 + 32',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Fahrenheit',
        signalUOMAbrv: '°F',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '°C',
            signalUOMFormulaName: 'Fahrenheit => Celsius',
            signalUOMFormulaType: 'Celsius',
            signalUOMFormula: '(n - 32) * 5/9',
        },
    },
    {
        signalUOM: 'Foot',
        signalUOMAbrv: 'ft',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'M',
            signalUOMFormulaName: 'Feet => Meters',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n / 3.2808',
        },
    },
    {
        signalUOM: 'Inch',
        signalUOMAbrv: 'in',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'M',
            signalUOMFormulaName: 'Inches => Meters',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n / 39.3701',
        },
    },
    {
        signalUOM: 'Pound',
        signalUOMAbrv: 'lbs',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'Kg',
            signalUOMFormulaName: 'Pounds => Kilograms',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n / 2.20462',
        },
    },
    {
        signalUOM: 'Decimal Degree',
        signalUOMAbrv: '°',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'No UOM',
        signalUOMAbrv: '',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Revolutions per Minute',
        signalUOMAbrv: 'RPM',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Pounds per Square Inch',
        signalUOMAbrv: 'PSI',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'kPa',
            signalUOMFormulaName: 'Pounds per Square Inch => Kilopascal',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n * 6.89476',
        },
    },
    {
        signalUOM: 'Liters per Hour',
        signalUOMAbrv: 'LPH',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'GPH',
            signalUOMFormulaName: 'Liters => Gallons per Hour',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n / 3.78541',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Gallons per Hour',
        signalUOMAbrv: 'GPH',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'LPH',
            signalUOMFormulaName: 'Gallons => Liters per Hour',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n * 3.78541',
        },
    },
    {
        signalUOM: 'Percent',
        signalUOMAbrv: '%',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Hertz',
        signalUOMAbrv: 'Hz',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Newton',
        signalUOMAbrv: 'N',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'lb',
            signalUOMFormulaName: 'Newtons => Pounds',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n * 0.224809',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Kilopascal',
        signalUOMAbrv: 'kPa',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'PSI',
            signalUOMFormulaName: 'Kilopascal => Pounds per Square Inch',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n / 6.89476',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Ohm',
        signalUOMAbrv: 'Ω',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Gallon',
        signalUOMAbrv: 'gal',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'L',
            signalUOMFormulaName: 'Gallons => Liters',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n * 3.78541',
        },
    },
    {
        signalUOM: 'Kilometers per Hour',
        signalUOMAbrv: 'KPH',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'MPH',
            signalUOMFormulaName: 'Kilometers => Miles',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n / 1.609344',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Miles per Hour',
        signalUOMAbrv: 'MPH',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'KPH',
            signalUOMFormulaName: 'Miles => Kilometers',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n * 1.609344',
        },
    },
    {
        signalUOM: 'Kilowatt',
        signalUOMAbrv: 'kW',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'HP',
            signalUOMFormulaName: 'Kilowatts => Horsepower',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n * 1.34102209',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Horsepower',
        signalUOMAbrv: 'HP',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'kW',
            signalUOMFormulaName: 'Horsepower => Kilowatts',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n / 1.34102209',
        },
    },
    {
        signalUOM: 'Foot-Pound',
        signalUOMAbrv: 'ft-lb',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'Nm',
            signalUOMFormulaName: 'Foot-Pounds => Newton-Meters',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n * 1.355817948',
        },
    },
    {
        signalUOM: 'Newton-Meter',
        signalUOMAbrv: 'Nm',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'ft-lb',
            signalUOMFormulaName: 'Newton-Meters => Foot-Pounds',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n / 1.355817948',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Kilometer',
        signalUOMAbrv: 'KM',
        signalImperialConversion: {
            signalUOMConversionAbrv: 'MI',
            signalUOMFormulaName: 'Kilometers => Miles',
            signalUOMFormulaType: 'Imperial',
            signalUOMFormula: 'n / 1.609344',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
    },
    {
        signalUOM: 'Mile',
        signalUOMAbrv: 'MI',
        signalImperialConversion: {
            signalUOMConversionAbrv: '',
            signalUOMFormulaName: '',
            signalUOMFormulaType: '',
            signalUOMFormula: '',
        },
        signalMetricConversion: {
            signalUOMConversionAbrv: 'KM',
            signalUOMFormulaName: 'Miles => Kilometers',
            signalUOMFormulaType: 'Metric',
            signalUOMFormula: 'n * 1.609344',
        },
    },
]

export default signalUnitOfMeasurements
